<div class="container">
	<div class="main-login main-center">
		<form class="form-horizontal" #registerForm="ngForm">
			<!-- Company -->
			<div class="form-group">
				<label for="name" class="cols-sm-2 control-label">{{ modelService.getString('reg_company') }}<span
						class="mandatory">*</span></label>
				<div class="input-group">
					<span class="input-group-text"><i class="fa fa-users" aria-hidden="true"></i></span>
					<input required type="text" class="form-control" name="empresa" id="empresa"
						[(ngModel)]="registerData.empresa"
						placeholder="{{ modelService.getString('reg_company_input') }}" />
				</div>
			</div>
			<!-- Impuesto -->
			<div class="form-group">
				<label for="username" class="cols-sm-2 control-label">{{ modelService.getString('reg_vat_number') }} <span
						class="mandatory">*</span></label>
				<div class="input-group">
					<span class="input-group-text"><i class="fa fa-balance-scale" aria-hidden="true"></i></span>
					<input required type="text" class="form-control" name="cif_nif" minlength="8" maxlength="9"
						id="cif_nif" [(ngModel)]="registerData.cif_nif"
						placeholder="{{ modelService.getString('reg_vat_number_input') }}" />
				</div>
			</div>
			<!-- Email -->
			<div class="form-group">
				<label for="email" class="cols-sm-2 control-label">{{ modelService.getString('reg_email') }} <span class="mandatory">*</span>
					<span *ngIf="existsEmail" style="color:red;">&nbsp;&nbsp;&nbsp;&nbsp;{{ modelService.getString('email_exists')}}</span>
				</label>
				<div class="input-group">
					<span class="input-group-text"><i class="fa fa-envelope fa" aria-hidden="true"></i></span>
					<input #email required type="email" class="form-control" name="email" id="email"
						[(ngModel)]="registerData.email" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
						placeholder="{{ modelService.getString('reg_email_input') }}" />
				</div>

			</div>
			<!-- Contraseñas -->
			<div class="form-group">
				<label for="password"
					class="cols-sm-2 control-label">{{ modelService.getString('password_register') }}<span class="mandatory">*</span></label>
				<div class="input-group">
					<span class="input-group-text"><i class="fa fa-lock fa-lg" aria-hidden="true"></i></span>
					<input #password1 required type="password" class="form-control" name="password" id="password"
						[(ngModel)]="registerData.password" minlength="4" maxlength="16"
						placeholder="{{ modelService.getString('password_register_input') }}" />
				</div>
			</div>
			<!-- Contraseñas 2 -->
			<div class="form-group">
				<label for="confirm"
					class="cols-sm-2 control-label">{{ modelService.getString('password2_register') }}<span class="mandatory">*</span></label>
				<div class="input-group">
					<span class="input-group-text"><i class="fa fa-lock fa-lg" aria-hidden="true"></i></span>
					<input #password2 required type="password" class="form-control" name="confirm" id="confirm"
						[(ngModel)]="registerData.password2" pattern="{{registerData.password}}" minlength="4"
						maxlength="16" placeholder="{{ modelService.getString('password2_register_input') }}" />
				</div>
			</div>
			<!-- Nombre -->
			<div class="form-group">
				<label for="nombre" class="cols-sm-2 control-label">{{ modelService.getString('reg_name') }}</label>
				<div class="input-group">
					<span class="input-group-text"><i class="fa fa-user fa" aria-hidden="true"></i></span>
					<input type="text" class="form-control" name="nombre" id="nombre" [(ngModel)]="registerData.nombre"
						placeholder="{{ modelService.getString('reg_name_input') }}" />
				</div>
			</div>
			<!-- Apellidos -->
			<div class="form-group">
				<label for="apellidos" class="cols-sm-2 control-label">{{ modelService.getString('reg_surname') }}</label>
				<div class="input-group">
					<span class="input-group-text"><i class="fa fa-user fa" aria-hidden="true"></i></span>
					<input type="text" class="form-control" name="apellidos" id="apellidos"
						[(ngModel)]="registerData.apellidos"
						placeholder="{{ modelService.getString('reg_surname_input') }}" />
				</div>
			</div>
			<!-- Código Rivisa -->
			<div class="form-group">
				<label for="codrivisa" class="cols-sm-2 control-label">{{ modelService.getString('reg_client_number') }}</label>
				<div class="input-group">
					<span class="input-group-text"><i class="fa fa-envelope fa" aria-hidden="true"></i></span>
					<input type="text" class="form-control" name="codrivisa" id="codrivisa" maxlength="5" [(ngModel)]="registerData.numCliRivisa"
						placeholder="{{ modelService.getString('reg_client_number_input') }}" />
				</div>
			</div>
			<!-- Enviar formulario -->
			<div class="form-group ">
				<button type="button" class="btn btn-primary btn-lg btn-block login-button"
					[disabled]="!registerForm.form.valid || loading" (click)="register()"><span
						*ngIf="!loading">{{ modelService.getString('register') }}</span><i *ngIf="loading"
						class="fa fa-spinner spin"></i></button>
			</div>
			<!-- Reiniciar <div class="login-register"><a routerLink="/login">{{ modelService.getString('reg_ back_login') }}</a></div-->
		</form>
	</div>
</div>
